export default "__VITE_ASSET__d877a1d7__"